import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import thunk from 'redux-thunk';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import HomeReducer from '../reducers/HomeReducer';
import CheckoutReducer from '../reducers/CheckoutReducer';
import PaymentReducer from '../reducers/PaymentReducer';
import SuccessReducer from '../reducers/SuccessReducer';
import myAccount from '../reducers/MyAccountReducer';
import ForgotPasswordReducer from '../reducers/ForgotPasswordReducer';
import ResetPasswordReducer from '../reducers/ResetPasswordReducer';
import ZuoraReducer from '../reducers/ZuoraReducer';
import SupportReducer from '../reducers/SupportReducer';
import plans from '../reducers/PlansReducer';
import PartnerMiddleware from '../middleware/PartnerMiddleware';
import VAReducer from '../reducers/VAReducer';
import ConfigReducer from '../reducers/ConfigReducer';
import ReSignReducer from '../reducers/ReSignReducer';

/* eslint-disable no-underscore-dangle */
const composeEnhancers = (process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__)
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  : compose;
/* eslint-enable */

const AppStore = createStore(
  combineReducers({
    routing: routerReducer,
    form: formReducer.plugin({
      checkout: CheckoutReducer, // 'checkout' is form name given to reduxForm()
      forgotPassword: ForgotPasswordReducer,
      resetPassword: ResetPasswordReducer
    }),
    home: HomeReducer,
    payment: PaymentReducer,
    success: SuccessReducer,
    myAccount,
    zuora: ZuoraReducer,
    support: SupportReducer,
    plans,
    va: VAReducer,
    config: ConfigReducer,
    reSign: ReSignReducer
  }),
  composeEnhancers(applyMiddleware(PartnerMiddleware, thunk))
);

export default AppStore;



/** WEBPACK FOOTER **
 ** ./src/redux/store/AppStore.js
 **/